<template>
  <div v-cloak id="app">
    <transition :name="transitionName">
      <keep-alive>
        <router-view class="appView" />
      </keep-alive>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      transitionName: ''
    }
  },
  watch: {
    // 使用watch 监听$router的变化
    $route (to, from) {
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (from.meta.index === 0) {
        this.transitionName = ''
      } else if (to.meta.index > from.meta.index) {
        // 设置动画名称
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>
<style scoped>
.appView {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease-out;
  backface-visibility: hidden; /* 防止有些浏览器动画闪烁 */
}

/* 进入动画 */
.slide-left-enter {
  transform: translateX(100%);
}

/* 离开动画 */
.slide-left-leave-active {
  transform: translateX(-100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

/* 进入动画 */
.slide-right-enter {
  transform: translateX(-100%);
}

/* 离开动画 */
.slide-right-leave-active {
  transform: translateX(100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

[v-cloak] {
  display: none;
}
</style>
